/* Elyra — page d'accueil : carrousels mobiles (Swiper) + pastilles couleur des cartes produit */
(function(){
  var MQ = window.matchMedia('(max-width: 749px)');
  var CFG = [
    ['[data-lma-bestsellers-slider]', {slidesPerView:1.2, spaceBetween:12}],
    ['[data-lma-brand-collections-slider]', {slidesPerView:1.2, spaceBetween:12}],
    ['[data-lma-looks-slider]', {slidesPerView:1.2, spaceBetween:12}],
    ['[data-lma-instagram-grid-slider]', {slidesPerView:1.2, spaceBetween:12}],
    ['[data-lma-brand-statistics-slider]', {slidesPerView:1, spaceBetween:0, loop:true, speed:650, autoplay:{delay:2400, disableOnInteraction:false}}]
  ];
  function apply(){
    if(!window.Swiper) return;
    CFG.forEach(function(c){
      document.querySelectorAll(c[0]).forEach(function(el){
        if(MQ.matches){ if(!el.swiper) new window.Swiper(el, c[1]); }
        else if(el.swiper){ el.swiper.destroy(true, true); }
      });
    });
  }
  function boot(){ apply(); if(MQ.addEventListener) MQ.addEventListener('change', apply); else MQ.addListener(apply); }
  if(window.Swiper) boot(); else window.addEventListener('load', boot);

  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-lma-product-card-swatch]');
    if(!b) return;
    var card = b.closest('[data-lma-product-card]'); if(!card) return;
    var img = card.querySelector('[data-lma-product-card-image]');
    if(img){ img.src = b.dataset.imageSrc; img.srcset = b.dataset.imageSrcset || ''; img.alt = b.dataset.imageAlt || img.alt; }
    if(b.dataset.productUrl) card.querySelectorAll('[data-lma-product-card-link]').forEach(function(a){ a.href = b.dataset.productUrl; });
    card.querySelectorAll('[data-lma-product-card-swatch]').forEach(function(s){ s.setAttribute('aria-pressed', s === b ? 'true' : 'false'); });
  });

  document.querySelectorAll('.lma-video-dots__video').forEach(function(v){
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); } else { v.pause(); } }); }, {threshold:.2}).observe(v);
    }
  });
})();
